import { TestData } from '../types';


export const sortTestsByNumber = (tests: TestData[]) => {
  return tests.sort((a, b) => a.sortingNumber - b.sortingNumber)
}
